// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.err_msg[data-v-43acf598] {color: red; font-weight: 500;}\n", ""]);
// Exports
module.exports = exports;
